/** @prettier */
// @flow

import React from 'react';
import './style.pcss';
import { connect } from 'react-redux';

import type { Subscription } from '#common/model/subscription';
import type { FiveSymbolLocale } from '#common/utils/locale';

import Button from '../../../ui-components/Editor/Button';

import { fiveSymbolsMap } from '#common/types/locale';

type BlurBlockProps = {
  locale: FiveSymbolLocale,
  block: Object,
  pageTheme: Object,
  subscriptionPlans: Subscription[],
};

const BlurBlock = ({
  pageTheme,
  block,
  subscriptionPlans,
  locale,
}: BlurBlockProps) => {
  const { pictureBackground } = pageTheme;
  const { values, module } = block;
  const { background } = values;
  const { img, size, color } =
    background && background.enable && background.img
      ? background
      : pictureBackground;
  const plans = subscriptionPlans
    .filter((sub) => values.private && values.private.includes(sub.external_id))
    .map((plan) => ({
      name: plan.name && (plan.name[fiveSymbolsMap[locale]] || plan.name.en),
      id: plan.external_id,
    }))
    .filter((plan) => plan && plan.name && plan.id);

  const planNames = plans.map((plan) => `"${plan.name}"`).join(', ');

  const planIds = plans.map((plan) => plan.id).join(',');

  return (
    <div className='blur-block' data-subscription-ids={planIds}>
      <div
        className='blur-block__background lazy'
        data-bg={`url(${img})`}
        data-size={size}
        style={{
          backgroundColor: color,
        }}
      />
      <div className={`blur-block__icon blur-block__icon--${module}`} />
      <div className='blur-block__inner'>
        <div className='blur-block__text' data-subscription-names={planNames} />
        <Button className='blur-block__button' />
      </div>
    </div>
  );
};

const connector: Function = connect(({ landing, pages, subscriptionData }) => ({
  subscriptionPlans: subscriptionData.subscriptionPlans,
  pageTheme: pages.pages[pages.currentPage].theme,
  locale: landing.locale,
}));

export default connector(BlurBlock);
